import { BaseIconProps } from "../../types/styles";

const DownloadIcon = ({
    id,
    className,
    size = 24,
    customColor,
    ...rest
}: BaseIconProps) => {
    const color = customColor ?? "var(--color-gray-800)";

    return (
        <svg
            {...rest}
            id={id ? `icon-${id}` : "icon-download"}
            className={className}
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            stroke={color}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            <path d="M12 15V3" />
            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
            <path d="m7 10 5 5 5-5" />
        </svg>
    );
};

export default DownloadIcon;
